import { render, staticRenderFns } from "./ShipperAfiliasi.vue?vue&type=template&id=5b79ef98"
import script from "./ShipperAfiliasi.vue?vue&type=script&lang=js"
export * from "./ShipperAfiliasi.vue?vue&type=script&lang=js"
import style0 from "./ShipperAfiliasi.vue?vue&type=style&index=0&id=5b79ef98&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports